/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Open newsletter popup on click a[href="#open-newsletter-popup"] 
  document.querySelectorAll('a[href="#open-newsletter-popup"]').forEach(function(link) {

    link.addEventListener('click', function(e) {
      e.preventDefault();

      var popup = document.querySelector('[data-large-promo]');
      if (!popup) return;

      // Find dialog inside popup
      var dialog = popup.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
        dialog.removeAttribute("inert");
        dialog.focus();
        document.dispatchEvent(new CustomEvent("theme:scroll:lock",{bubbles:!0}))
      }
    });

  });



  // Header search dynamic placeholder
  document.querySelectorAll('input[data-predictive-search-input]').forEach(function(searchInput) {
    if (searchInput) {
      const placeholders = JSON.parse(searchInput.dataset.placeholders);
      let index = 0;

      function changePlaceholder() {
        index = (index + 1) % placeholders.length;
        searchInput.placeholder = placeholders[index];
      }

      setInterval(changePlaceholder, 15000); // 15000ms = 15 seconds
    }
  });

  




  // OMNIA258 2026-07-13 — In-stock-aware size filter (Ready to Ship)
  // Shopify's native size facet (filter.v.option.size) matches any product that HAS
  // that size, even when it's out of stock. filters.liquid renders a disabled hidden
  // input [data-sc-instock-toggle] (name="filter.v.availability" value="1") on RTS
  // collections. Here we enable it ONLY while a size is selected, so Shopify returns
  // only products whose selected size is actually in stock. With no size chosen the
  // input stays disabled and the collection shows normally. Handles multiple sizes
  // (M+L) automatically — Shopify combines size (OR) with availability (AND) per variant.
  function scSyncInstockToggle(form) {
    var toggle = form.querySelector('[data-sc-instock-toggle]');
    if (!toggle) return;
    // A size is considered selected if any checked checkbox targets the size option facet.
    var sizeSelected = form.querySelector('input[name^="filter.v.option.size"]:checked');
    toggle.disabled = !sizeSelected;
  }

  // Capture phase so the hidden input's state is updated BEFORE the theme's own filter
  // handler reads the form's FormData. Delegated on document so it survives the AJAX
  // re-renders that swap the filter form markup.
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || typeof el.closest !== 'function') return;
    var form = el.closest('[data-collection-filters-form]');
    if (form) scSyncInstockToggle(form);
  }, true);

  // Initial sync on page load for any filter form already present.
  document.querySelectorAll('[data-collection-filters-form]').forEach(function (form) {
    scSyncInstockToggle(form);
  });


  // OMNIA258 2026-07-14 — Size chart inches/cm toggle.
  // The size-chart snippet renders each measurement as <span class="sc-in"> + <span class="sc-cm">;
  // CSS shows one based on the container's data-unit. Here we just flip that attribute on click.
  // Delegated on document so it also works inside the (AJAX/dialog) size-chart modal.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-sc-unit]') : null;
    if (!btn) return;
    var chart = btn.closest('[data-sc-chart]');
    if (!chart) return;
    chart.setAttribute('data-unit', btn.getAttribute('data-sc-unit'));
    chart.querySelectorAll('[data-sc-unit]').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
    });
  });


  // OMNIA258 2026-07-15 — First-visit autoplay fix for background videos.
  // The theme's VideoBackground calls play() the instant it stamps the <template>
  // markup; with <source media> children the element can land in a "no supported
  // source" dead state (browser source-selection race) that its retries never
  // escape — so the hero looked frozen on first visit and only played after a
  // reload. load() is the official reset: it re-runs source selection cleanly,
  // then play() starts it deterministically. Runs once per video, still lazy
  // (we only react after the theme stamps the markup near the viewport).
  function scKickVideo(vb) {
    var v = vb.querySelector('video');
    if (!v || v.dataset.scKicked) return;
    v.dataset.scKicked = '1';
    try { v.load(); } catch (e) {}
    var p = v.play();
    if (p && p.catch) p.catch(function () {
      // Autoplay refused (e.g. iOS Low Power Mode) — retry on the first interaction.
      var retry = function () {
        var rp = v.play();
        if (rp && rp.catch) rp.catch(function () {});
      };
      document.addEventListener('touchstart', retry, { once: true, passive: true });
      document.addEventListener('click', retry, { once: true });
    });
  }
  function scWatchVideoBackgrounds(root) {
    (root || document).querySelectorAll('video-background').forEach(function (vb) {
      if (vb.dataset.scWatched) return;
      vb.dataset.scWatched = '1';
      if (vb.querySelector('video')) { scKickVideo(vb); return; }
      new MutationObserver(function (mutations, obs) {
        if (vb.querySelector('video')) { scKickVideo(vb); obs.disconnect(); }
      }).observe(vb, { childList: true });
    });
  }
  scWatchVideoBackgrounds(document);
  // Theme editor re-renders sections without a page load — kick the fresh elements too.
  document.addEventListener('shopify:section:load', function (e) {
    scWatchVideoBackgrounds(e.target);
  });


  // OMNIA258 2026-07-16 — Add-on products (Product type "Add-on", e.g. potlis) must not
  // be browsable from upsell cards. CSS disables their card links (custom.css §17); this
  // is the backstop for keyboard navigation and any markup path CSS misses. Delegated on
  // document so it survives cart-drawer re-renders. Products without the "Add-on" type
  // are never affected.
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('[data-sc-addon-type="Add-on"] a') : null;
    if (!link) return;
    if (link.closest('form') || link.hasAttribute('data-quick-add-btn')) return; // never block the ADD flow
    e.preventDefault();
    e.stopPropagation();
  }, true);


  // OMNIA258 2026-09-12 — Gift card denominations: Shopify auto-names them with
  // trailing ".00" (e.g. ₹5,000.00). Liquid strips it on first render
  // (product-variant-options.liquid); this keeps the selected-value label clean
  // after the theme's JS rewrites it on selection. Gift card pages only
  // (data-giftcard-money marker), runs per change event, no cost elsewhere.
  document.addEventListener('change', function (e) {
    var holder = e.target.closest ? e.target.closest('[data-giftcard-money]') : null;
    if (!holder) return;
    requestAnimationFrame(function () {
      holder.querySelectorAll('[data-option-value]').forEach(function (el) {
        if (el.textContent.indexOf('.00') !== -1) {
          el.textContent = el.textContent.replace('.00', '');
        }
      });
    });
  });


  // OMNIA258 2026-09-12 — Gift card "Send on" timezone accuracy. Shopify schedules
  // the recipient email using the buyer's timezone from the __shopify_offset
  // property, but this theme's recipient-form never fills it (falls back to store
  // timezone). Mirror Dawn: when the gift checkbox is ticked, enable the offset
  // field with the buyer's offset; disable it again when unticked.
  document.addEventListener('change', function (e) {
    var rf = e.target.closest ? e.target.closest('recipient-form') : null;
    if (!rf || e.target.type !== 'checkbox') return;
    var offset = rf.querySelector('input[name="properties[__shopify_offset]"]');
    if (!offset) return;
    offset.disabled = !e.target.checked;
    if (e.target.checked) offset.value = new Date().getTimezoneOffset().toString();
  });


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
